import { Page } from "@/models/page-models/Page";

export const Customer: Page = {
  "path": "customers",
  "name": "Customer",
  "props": {
    "data": {
      "title": "Customer",
      "printable": "FALSE",
      "url": "customers",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Add New Customer",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToCustomerCreate",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/customers/new"
                      },
                      "name": "redirectToCustomerCreate"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_DEPARTMENT,SALES))"
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Open Customer",
              "bracketValueFormula": "{{fetchedData.openCustomers.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Open Customer",
                      "disabled": "FALSE",
                      "items": "fetchedData.openCustomers.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Id",
                          "type": "url",
                          "url": "/customers/{{__item._id}}"
                        },
                        {
                          "value": "__item.name",
                          "text": "Customer Name"
                        },
                        {
                          "value": "alias",
                          "text": "Alias"
                        },
                        {
                          "value": "assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "CRNumber",
                          "text": "CR#"
                        },
                        {
                          "value": "status",
                          "text": "Type",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.customerType}},'),==,'Regular'),{{__item.status}},fn(CONCAT,{{__item.customerType}}, ,{{__item.status}}))"
                        },
                        {
                          "value": "groups",
                          "text": "Groups",
                          "formula": "fn(HELPER_FN,joinArray,{{__item.groups}},name)"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Created At",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "active",
                          "text": "Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,agingStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultPageAndLimit",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getDefaultPageAndLimit",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.openCustomerForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyDefaultPageAndLimit"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getAllSalesOpenCustomers",
                          "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getMySalesOpenCustomers",
                          "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getAllOpenCustomers",
                          "executeIf": "fn(MATCH_ROLE,General Manager)"
                        }
                      ],
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Disable",
                          "showIf": "fn(MATCH_ROLE,General Manager)",
                          "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,{{__arrayItem.active}},==,true),{{__item}},_id),!==,fn(LENGTH,{{__item}}))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "disableCustomer",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer/{{__item._id}}/disable-customer",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "disableCustomer"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.openCustomerForm.page",
                        "serverItemsLengthVariable": "fetchedData.openCustomers.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getAllSalesOpenCustomers",
                            "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
                          },
                          {
                            "executionOrder": 2,
                            "name": "getMySalesOpenCustomers",
                            "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
                          },
                          {
                            "executionOrder": 2,
                            "name": "getAllOpenCustomers",
                            "executeIf": "fn(MATCH_ROLE,General Manager)"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.openCustomerForm.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Pending Prospect",
              "bracketValueFormula": "{{fetchedData.pendingProspects.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Prospect",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingProspects.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Id",
                          "type": "url",
                          "url": "/customers/{{__item._id}}"
                        },
                        {
                          "value": "__item.name",
                          "text": "Customer Name"
                        },
                        {
                          "value": "alias",
                          "text": "Alias"
                        },
                        {
                          "value": "assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "status",
                          "text": "Type",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.customerType}},'),==,'Regular'),{{__item.status}},fn(CONCAT,{{__item.customerType}}, ,{{__item.status}}))"
                        },
                        {
                          "value": "groups",
                          "text": "Groups",
                          "formula": "fn(HELPER_FN,joinArray,{{__item.groups}},name)"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Created At",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "active",
                          "text": "Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,agingStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultPageAndLimit",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getDefaultPageAndLimit",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.pendingProspectForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyDefaultPageAndLimit"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getAllSalesPendingProspects",
                          "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getMySalesPendingProspects",
                          "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getAllPendingProspects",
                          "executeIf": "fn(MATCH_ROLE,General Manager)"
                        }
                      ],
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Disable",
                          "showIf": "fn(MATCH_ROLE,General Manager)",
                          "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,{{__arrayItem.active}},==,true),{{__item}},_id),!==,fn(LENGTH,{{__item}}))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "disableCustomer",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer/{{__item._id}}/disable-customer",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "disableCustomer"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.pendingProspectForm.page",
                        "serverItemsLengthVariable": "fetchedData.pendingProspects.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getAllSalesPendingProspects",
                            "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
                          },
                          {
                            "executionOrder": 2,
                            "name": "getMySalesPendingProspects",
                            "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
                          },
                          {
                            "executionOrder": 2,
                            "name": "getAllPendingProspects",
                            "executeIf": "fn(MATCH_ROLE,General Manager)"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.pendingProspectForm.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Open Prospect",
              "bracketValueFormula": "{{fetchedData.openProspects.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Open Prospect",
                      "disabled": "FALSE",
                      "items": "fetchedData.openProspects.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Id",
                          "type": "url",
                          "url": "/customers/{{__item._id}}"
                        },
                        {
                          "value": "__item.name",
                          "text": "Customer Name"
                        },
                        {
                          "value": "alias",
                          "text": "Alias"
                        },
                        {
                          "value": "assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "status",
                          "text": "Type",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.customerType}},'),==,'Regular'),{{__item.status}},fn(CONCAT,{{__item.customerType}}, ,{{__item.status}}))"
                        },
                        {
                          "value": "groups",
                          "text": "Groups",
                          "formula": "fn(HELPER_FN,joinArray,{{__item.groups}},name)"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Created At",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "active",
                          "text": "Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,agingStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultPageAndLimit",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getDefaultPageAndLimit",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.openProspectForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyDefaultPageAndLimit"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getAllSalesOpenProspects",
                          "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getMySalesOpenProspects",
                          "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getAllOpenProspects",
                          "executeIf": "fn(MATCH_ROLE,General Manager)"
                        }
                      ],
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Disable",
                          "showIf": "fn(MATCH_ROLE,General Manager)",
                          "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,{{__arrayItem.active}},==,true),{{__item}},_id),!==,fn(LENGTH,{{__item}}))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "disableCustomer",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer/{{__item._id}}/disable-customer",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "disableCustomer"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.openProspectForm.page",
                        "serverItemsLengthVariable": "fetchedData.openProspects.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getAllSalesOpenProspects",
                            "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
                          },
                          {
                            "executionOrder": 2,
                            "name": "getMySalesOpenProspects",
                            "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
                          },
                          {
                            "executionOrder": 2,
                            "name": "getAllOpenProspects",
                            "executeIf": "fn(MATCH_ROLE,General Manager)"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.openProspectForm.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Closed Customer",
              "bracketValueFormula": "{{fetchedData.closedCustomers.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Closed Customer",
                      "disabled": "FALSE",
                      "items": "fetchedData.closedCustomers.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Id",
                          "type": "url",
                          "url": "/customers/{{__item._id}}"
                        },
                        {
                          "value": "__item.name",
                          "text": "Customer Name"
                        },
                        {
                          "value": "alias",
                          "text": "Alias"
                        },
                        {
                          "value": "assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "status",
                          "text": "Type",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.customerType}},'),==,'Regular'),{{__item.status}},fn(CONCAT,{{__item.customerType}}, ,{{__item.status}}))"
                        },
                        {
                          "value": "groups",
                          "text": "Groups",
                          "formula": "fn(HELPER_FN,joinArray,{{__item.groups}},name)"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Created At",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "active",
                          "text": "Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,agingStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultPageAndLimit",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getDefaultPageAndLimit",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.closedCustomerForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyDefaultPageAndLimit"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getAllSalesClosedCustomers",
                          "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getMySalesClosedCustomers",
                          "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getAllClosedCustomers",
                          "executeIf": "fn(MATCH_ROLE,General Manager)"
                        }
                      ],
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Enable",
                          "showIf": "fn(MATCH_ROLE,General Manager)",
                          "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(NOT,{{__arrayItem.active}}),{{__item}},_id),!==,fn(LENGTH,{{__item}}))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "copySelectedCustomer",
                                "type": "fnCopyData",
                                "arg1Key": "sourceKey",
                                "arg1Value": "__item",
                                "arg2Key": "destinationKey",
                                "arg2Value": "fetchedData.selectedCustomer"
                              },
                              "name": "copySelectedCustomer"
                            },
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "copyDefaultOverrideDate",
                                "type": "fnCopyData",
                                "arg1Key": "sourceFn",
                                "arg1Value": "getDefaultOverrideDate",
                                "arg2Key": "destinationKey",
                                "arg2Value": "fetchedData.enableCustomerForm"
                              },
                              "name": "copyDefaultOverrideDate"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "openEnableCustomerPopup",
                                "type": "fnOpenPopup",
                                "arg1Key": "popupName",
                                "arg1Value": "Enable Customer"
                              },
                              "name": "openEnableCustomerPopup"
                            }
                          ]
                        },
                        {
                          "label": "Delete",
                          "showIf": "fn(MATCH_ROLE,General Manager)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "deleteCustomer",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer/{{__item._id}}/delete",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "deleteCustomer"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.closedCustomerForm.page",
                        "serverItemsLengthVariable": "fetchedData.closedCustomers.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getAllSalesClosedCustomers",
                            "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
                          },
                          {
                            "executionOrder": 2,
                            "name": "getMySalesClosedCustomers",
                            "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
                          },
                          {
                            "executionOrder": 2,
                            "name": "getAllClosedCustomers",
                            "executeIf": "fn(MATCH_ROLE,General Manager)"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.closedCustomerForm.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Closed Prospect",
              "bracketValueFormula": "{{fetchedData.closedProspects.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Closed Prospect",
                      "disabled": "FALSE",
                      "items": "fetchedData.closedProspects.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Id",
                          "type": "url",
                          "url": "/customers/{{__item._id}}"
                        },
                        {
                          "value": "__item.name",
                          "text": "Customer Name"
                        },
                        {
                          "value": "alias",
                          "text": "Alias"
                        },
                        {
                          "value": "assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "status",
                          "text": "Type",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.customerType}},'),==,'Regular'),{{__item.status}},fn(CONCAT,{{__item.customerType}}, ,{{__item.status}}))"
                        },
                        {
                          "value": "groups",
                          "text": "Groups",
                          "formula": "fn(HELPER_FN,joinArray,{{__item.groups}},name)"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Created At",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "active",
                          "text": "Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,agingStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultPageAndLimit",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getDefaultPageAndLimit",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.closedProspectForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyDefaultPageAndLimit"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getAllSalesClosedProspects",
                          "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getMySalesClosedProspects",
                          "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getAllClosedProspects",
                          "executeIf": "fn(MATCH_ROLE,General Manager)"
                        }
                      ],
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Enable",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,SALES_MANAGER))",
                          "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(NOT,{{__arrayItem.active}}),{{__item}},_id),!==,fn(LENGTH,{{__item}}))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "copySelectedCustomer",
                                "type": "fnCopyData",
                                "arg1Key": "sourceKey",
                                "arg1Value": "__item",
                                "arg2Key": "destinationKey",
                                "arg2Value": "fetchedData.selectedCustomer"
                              },
                              "name": "copySelectedCustomer"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "enableCustomer",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer/{{fetchedData.selectedCustomer._id}}/enable-customer",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "enableCustomer"
                            }
                          ]
                        },
                        {
                          "label": "Delete",
                          "showIf": "fn(MATCH_ROLE,General Manager)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "deleteCustomer",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer/{{__item._id}}/delete",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "deleteCustomer"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.closedProspectForm.page",
                        "serverItemsLengthVariable": "fetchedData.closedProspects.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getAllSalesClosedProspects",
                            "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
                          },
                          {
                            "executionOrder": 2,
                            "name": "getMySalesClosedProspects",
                            "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
                          },
                          {
                            "executionOrder": 2,
                            "name": "getAllClosedProspects",
                            "executeIf": "fn(MATCH_ROLE,General Manager)"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.closedProspectForm.limit"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Enable Customer",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Select date for System Checking"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "fetchedData.enableCustomerForm.skipDisableUntil",
                  "label": "Skip Until",
                  "disabled": "FALSE",
                  "minDateFormula": "fn(HELPER_FN,dateFormat,fn(ADD_DAYS,{{TODAYS_DATE}},1),date-picker)"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Enable",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "enableCustomer",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/customer/{{fetchedData.selectedCustomer._id}}/enable-customer",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.enableCustomerForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "enableCustomer"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingProspectForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingProspectForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.pendingProspectForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultPendingProspectForm"
      },
      {
        "executionOrder": 2,
        "name": "getAllSalesPendingProspects",
        "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
      },
      {
        "executionOrder": 2,
        "name": "getMySalesPendingProspects",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 2,
        "name": "getAllPendingProspects",
        "executeIf": "fn(MATCH_ROLE,General Manager)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultOpenProspectForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOpenProspectForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.openProspectForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultOpenProspectForm"
      },
      {
        "executionOrder": 2,
        "name": "getAllSalesOpenProspects",
        "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
      },
      {
        "executionOrder": 2,
        "name": "getMySalesOpenProspects",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 2,
        "name": "getAllOpenProspects",
        "executeIf": "fn(MATCH_ROLE,General Manager)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultOpenCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOpenCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.openCustomerForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultOpenCustomerForm"
      },
      {
        "executionOrder": 2,
        "name": "getAllSalesOpenCustomers",
        "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
      },
      {
        "executionOrder": 2,
        "name": "getMySalesOpenCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 2,
        "name": "getAllOpenCustomers",
        "executeIf": "fn(MATCH_ROLE,General Manager)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultClosedCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultClosedCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.closedCustomerForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultClosedCustomerForm"
      },
      {
        "executionOrder": 2,
        "name": "getAllSalesClosedCustomers",
        "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
      },
      {
        "executionOrder": 2,
        "name": "getMySalesClosedCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 2,
        "name": "getAllClosedCustomers",
        "executeIf": "fn(MATCH_ROLE,General Manager)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultClosedProspectForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultClosedProspectForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.closedProspectForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultClosedProspectForm"
      },
      {
        "executionOrder": 2,
        "name": "getAllSalesClosedProspects",
        "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),||,fn(MATCH_ROLE,General Manager)))"
      },
      {
        "executionOrder": 2,
        "name": "getMySalesClosedProspects",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 2,
        "name": "getAllClosedProspects",
        "executeIf": "fn(MATCH_ROLE,General Manager)"
      }
    ],
    "functions": [
      {
        "name": "getDefaultPageAndLimit",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1",
          "limit": "50",
          "pattern": "{{__selectedObject}}"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultPendingProspectForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "paginate": true,
          "limit": 50,
          "pattern": "",
          "showDisabled": true,
          "status": ["Pending Prospect"]
        },
        "staticObject": true
      },
      {
        "name": "getAllSalesPendingProspects",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.pendingProspects",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.pendingProspectForm"
      },
      {
        "name": "getAllPendingProspects",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers?showMisc=true",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.pendingProspects",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.pendingProspectForm"
      },
      {
        "name": "getMySalesPendingProspects",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/my-customers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.pendingProspects",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.pendingProspectForm"
      },
      {
        "name": "getDefaultOpenProspectForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "paginate": true,
          "limit": 40,
          "pattern": "",
          "showDisabled": true,
          "status": ["Open Prospect"]
        },
        "staticObject": true
      },
      {
        "name": "getAllSalesOpenProspects",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.openProspects",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.openProspectForm"
      },
      {
        "name": "getAllOpenProspects",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers?showMisc=true",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.openProspects",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.openProspectForm"
      },
      {
        "name": "getMySalesOpenProspects",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/my-customers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.openProspects",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.openProspectForm"
      },
      {
        "name": "getDefaultOpenCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "paginate": true,
          "limit": 50,
          "pattern": "",
          "showDisabled": true,
          "status": ["Open Customer"]
        },
        "staticObject": true
      },
      {
        "name": "getAllSalesOpenCustomers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.openCustomers",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.openCustomerForm"
      },
      {
        "name": "getAllOpenCustomers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers?showMisc=true",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.openCustomers",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.openCustomerForm"
      },
      {
        "name": "getMySalesOpenCustomers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/my-customers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.openCustomers",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.openCustomerForm"
      },
      {
        "name": "getDefaultClosedCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "paginate": true,
          "limit": 50,
          "pattern": "",
          "showDisabled": true,
          "status": ["Closed Customer"]
        },
        "staticObject": true
      },
      {
        "name": "getAllSalesClosedCustomers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.closedCustomers",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.closedCustomerForm"
      },
      {
        "name": "getAllClosedCustomers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers?showMisc=true",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.closedCustomers",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.closedCustomerForm"
      },
      {
        "name": "getMySalesClosedCustomers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/my-customers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.closedCustomers",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.closedCustomerForm"
      },
      {
        "name": "getDefaultClosedProspectForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "paginate": true,
          "limit": 50,
          "pattern": "",
          "showDisabled": true,
          "status": ["Closed Prospect"]
        },
        "staticObject": true
      },
      {
        "name": "getAllSalesClosedProspects",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.closedProspects",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.closedProspectForm"
      },
      {
        "name": "getAllClosedProspects",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers?showMisc=true",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.closedProspects",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.closedProspectForm"
      },
      {
        "name": "getMySalesClosedProspects",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/my-customers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.closedProspects",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.closedProspectForm"
      },
      {
        "name": "getDefaultOverrideDate",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "skipDisableUntil": "fn(HELPER_FN,dateFormat,fn(ADD_DAYS,{{TODAYS_DATE}},1),date-picker)"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,CUSTOMER_SERVICE_MANAGER,ACCOUNTING_COSTING,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE,GENERAL_MANAGER,QA_MANAGER",
  "visible": true,
  "routerPriority": 80
}